import { render, staticRenderFns } from "./HrDocumentDiffDialog.vue?vue&type=template&id=0cad22ba&"
import script from "./HrDocumentDiffDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentDiffDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports